module.exports = __webpack_public_path__ + "static/media/factory.4688a9b2.svg";